import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox';
import { CheckIcon } from 'lucide-react';

import { cn } from '../../common/helpers/cn';

function Checkbox({ className, checked, disabled, ...props }: CheckboxPrimitive.Root.Props) {
  const backgroundColor = disabled ? 'var(--color-grey-100)' : checked ? 'var(--color-orange-400)' : 'white';
  const borderColor = disabled
    ? 'var(--color-grey-100) !important'
    : checked
      ? 'var(--color-orange-400) !important'
      : undefined;
  const color = disabled ? 'var(--color-grey-200)' : checked ? 'white' : undefined;

  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'size-4 group-has-disabled/field:opacity-50 focus-visible:ring-3 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary peer relative flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[4px] border !border-grey-300 border-input outline-none transition-colors after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-input/30',
        className
      )}
      style={{
        backgroundColor,
        borderColor,
        color,
      }}
      disabled={disabled}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="[&>svg]:size-3.5 grid place-content-center text-current transition-none"
      >
        <CheckIcon className="h-4 w-4" strokeWidth={3} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
